import React, { useCallback, useContext } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import Group from 'components/utils/Group'
import FilterChip from 'LuxKit/Chips/FilterChip'
import { getCurrentDateLabel } from '../../FlashHotel/FlashHotelMobileVariant/FlashHotelMobileVariantUtils'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import ModalContext from 'contexts/ModalContext'
import ModalBase from 'LuxKit/Modal/ModalBase'
import BedbankSidebarFilterCalendar from '../BedbankSidebarFilterCalendar'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { BusinessTravellerMultiRoomHotelsOfferPageMobile, BusinessTravellerMultiRoomHotelsOfferPageMobileDisabled } from 'businessTraveller/components/select-traveller/multi-room-hotels'
import BusinessTravellerAccountGuard from 'businessTraveller/components/BusinessTravellerAccountGuard'
import BusinessTravellerSelectLoadingSkeleton from 'businessTraveller/components/select-traveller/BusinessTravellerSelectLoadingSkeleton'

interface Props {
  dateLabel: string;
}

function BedbankMobileStickyHeaderFilters(props: Props) {
  const {
    dateLabel,
  } = props

  const dispatch = useOfferPageDispatch()
  const showModal = useContext(ModalContext)

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeHeaderFilter })
  }, [dispatch])

  const onOpenCalendar = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleHeaderFilter, filter: 'checkin' })

    showModal(<ModalBase mode="drawer"><BedbankSidebarFilterCalendar /></ModalBase>).then(onClose)
  }, [dispatch, showModal, onClose])

  return (
    <Group direction="horizontal" gap={8} wrap="wrap">
      <BusinessTravellerAccountGuard
        employeeRoles={['BUSINESS_ADMIN', 'BUSINESS_MANAGER']}
        loading={<BusinessTravellerSelectLoadingSkeleton />}
        fallback={<BusinessTravellerMultiRoomHotelsOfferPageMobileDisabled />}
      >
        <BusinessTravellerMultiRoomHotelsOfferPageMobile />
      </BusinessTravellerAccountGuard>
      <FilterChip
        startIcon={<LineCalendarIcon />}
        size="medium"
        onClick={onOpenCalendar}
        data-testid="OfferDatePickerSelectBox"
      >
      {dateLabel || 'Anytime'}
      </FilterChip>
    </Group>
  )
}

export default withOfferPageAndReduxState((offerState) => ({
  dateLabel: getCurrentDateLabel(offerState),
}), BedbankMobileStickyHeaderFilters)
